import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const SwitchHorizontal = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M5.3335 4.66667L13.3335 4.66667M13.3335 4.66667L10.6668 2M13.3335 4.66667L10.6668 7.33333M10.6668 11.3333L2.66683 11.3333M2.66683 11.3333L5.3335 14M2.66683 11.3333L5.3335 8.66667"
      stroke="#010F55"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SwitchHorizontal;
